// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { OnePageCheckoutShippingSectionStyles } from "@bg/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Cart } from "@insite/client-framework/Services/CartService";
import setStorePickupOverlayIsOpen from "@insite/client-framework/Store/Components/StorePickupOverlay/Handlers/SetStorePickupOverlayIsOpen";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    cart?: Cart;
}

const mapStateToProps = (state: CustomAppState) => ({
    pickUpWarehouse: getSession(state).pickUpWarehouse,
});

const mapDispatchToProps = {
    setStorePickupOverlayIsOpen,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface OnePageCheckoutPickupAddressStyles {
    container?: InjectableCss;
    titleContainer?: InjectableCss;
    heading?: TypographyPresentationProps;
    addressInfoDisplay?: AddressInfoDisplayStyles;
    pickupFullAddressContainer?: InjectableCss;
}

export const onePageCheckoutPickupAddressStyles: OnePageCheckoutPickupAddressStyles = {};

const styles = onePageCheckoutPickupAddressStyles;
const OnePageCheckoutPickupAddress: FC<Props> = ({ cart, pickUpWarehouse }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="OnePageCheckoutPickupAddress">
            <StyledWrapper {...styles.titleContainer}>
                <Typography {...styles.heading}>{translate("Pick Up Address")}</Typography>
            </StyledWrapper>
            {cart?.type === "Quote" && !!cart?.properties.originalPickupFullAddress && (
                <StyledWrapper
                    {...styles.pickupFullAddressContainer}
                    data-test-selector="OnePageCheckoutPickupAddress_OriginalPickupFullAddress"
                >
                    {cart?.properties.originalPickupFullAddress}
                </StyledWrapper>
            )}
            {!cart?.properties.originalPickupFullAddress && pickUpWarehouse && (
                <AddressInfoDisplay
                    {...pickUpWarehouse}
                    companyName={pickUpWarehouse.description || pickUpWarehouse.name}
                    extendedStyles={styles.addressInfoDisplay}
                />
            )}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OnePageCheckoutPickupAddress);
